import DateFilter from '@/components/date-filter'
import store_configs from '@/store/mods/parametres/config'
import $ from 'jquery'

export default {
    name: 'historique-configs',
    components: {
        DateFilter
    },
    props: {
        data_type: String,
        toggler: Number,
    },
    data() {
        return {
            current_date_filter: {},
            curr_month: "",          // Current month of the year
            filter_date: '',

            date_filters: [
                { slug: 'date', libelle: 'Date' },
                { slug: 'entre_deux_date', libelle: 'Entre deux dates' }
            ],
            filter_by_date: { slug: '', libelle: '' },

            fields: [
                'date', 'auteur', { key: 'old_value', label: 'Ancienne valeur' },
                { key: 'new_value', label: 'Nouvelle valeur' }
            ],

            filter: "",
            perPage: -1,
            currentPage: 1,
            is_loading: false,
            is_empty: true,
            is_load_error: false,
            liste_historique: []
        }
    },

    watch: {
        filter_date() {
            if (this.filter_date != '') {
                this.filter_by_date = this.filter_date;
                if (this.filter_by_date.slug) {
                    $('.date-filter').modal('show')
                }
            }
        },

        curr_month() {
            const data = {
                data_type: this.data_type,
                month: this.curr_month.id,
                one_date: "",
                from_date: "",
                to_date: ""
            }
            this.current_date_filter = data
            this.fetchHistorique(data)
        },

        toggler() {
            this.fetchHistorique(this.current_date_filter)
        }
    },

    computed: {
        monthOfYear() {
            let index;
            var m = []
            for (index = 0; index <= this.current_date.getMonth() + 1; index++) {
                m[index] = this.list_months[index];
            }
            return m;
        },
    },

    mounted() {
        this.curr_month = this.monthOfYear[this.current_date.getMonth()+1]
    },

    methods: {
        filterByDate(date) {
            this.selected_operations = []
            const data = {
                data_type: this.data_type,
                month: "",
                one_date: date.single_date,
                from_date: date.from_date,
                to_date: date.to_date,
                from_hour: date.from_hour,
                to_hour: date.to_hour,
            }
            this.current_date_filter = data
            this.filter_date = ""

            this.fetchHistorique(data)
        },

        fetchHistorique(data) {
            this.is_loading = true

            store_configs.getHistoriqueConfig(data).then((historique) => {
                this.liste_historique = historique

                if (this.liste_historique.length > 0) {
                    this.is_empty = false
                } else {
                    this.is_empty = true
                }
                this.is_loading = false
            }).catch(() => {
                this.is_load_error = true
                this.is_loading = false
            })
        }
    }
}